import { LazyLoadOnIdle } from '@ms/yammer-libs-lazy';
import Null from '@ms/yammer-libs-null';
import React, { FC } from 'react';

const loader = () => import(/* webpackChunkName: "4-feat-toast" */ './Toast');

const LoadableToast: FC = () => <LazyLoadOnIdle loader={loader} Placeholder={Null} />;

export default LoadableToast;
